'use client';

import PageLayout from '@organisms/PageLayout/PageLayout';
import ProductBeamSkeleton from '@molecules/ProductBeam/ProductBeam.skeleton';

/**
 * Placeholder shown while a category page resolves its route params and CMS page.
 * Mirrors the layout of WillysCategoryTemplate so the content swaps in without shifting.
 */
const CategoryPageSkeleton = () => (
  <PageLayout>
    <ProductBeamSkeleton type="categoryBeam" rows={2} />
  </PageLayout>
);

export default CategoryPageSkeleton;
